import { createAxiosClient, ServiceProxyMap } from '@atlassian/temp-client-utils';
import { RemovePaymentMethodRequest } from '@atlassian/cssxp-typescommon';

const client = createAxiosClient({ baseURL: '/api/1/payment-method' }, ServiceProxyMap.ANS);

export async function deletePaymentMethodById(request: RemovePaymentMethodRequest) {
  const { transactionAccountId, paymentMethodId } = request;
  const response = await client.delete(`/${paymentMethodId}`, {
    headers: {
      transactionAccountId,
    },
  });

  return response.status;
}
